<template>
  <h4 class="simpleTitle">
    {{text}}
  </h4>
</template>

<script>
export default {
  name: 'simpleTitle',
  props: ['text']
}
</script>

<style lang="scss">


  .simpleTitle {
    color: color(grey-dark);
    font-weight: 700;
    margin: 0;
    font-size: rem(18px);
    line-height: rem(24px);

    @include mq($until: MD) {
      font-size: rem(16px);
    }
  }

</style>
